import { CurrencyType } from "@bitwarden/web-vault/app/models/types/location-currency.types";
import { ExternalView } from "@bitwarden/web-vault/app/models/view/external.view";
import {
  SubscriptionTier,
  SubscriptionPaymentCycle,
  SubscriptionPaymentProvider,
} from "@bitwarden/web-vault/app/models/types/subscription.type";

export type SubscriptionResponse = {
  payment_provider: SubscriptionPaymentProvider;
  payment_provider_customer_id: string;
  payment_cycle: SubscriptionPaymentCycle;
  fee: number;
  currency: CurrencyType;
  subscription_id: string;
  active: boolean;
  date_start: string;
  date_end: string;
  date_renewal: string;
  tier: SubscriptionTier;
  comment: string;
  auto_renew: boolean;
  trial_start: string;
  with_card: boolean;
};

export class SubscriptionView extends ExternalView {
  paymentProvider: SubscriptionPaymentProvider;
  paymentProviderCustomerId: string;
  paymentCycle: SubscriptionPaymentCycle;
  fee: number;
  id: string | null;
  currency: CurrencyType;
  active: boolean;
  startDate: Date;
  endDate: Date;
  renewalDate: Date;
  tier: SubscriptionTier;
  comment: string;
  autoRenew: boolean;
  isPremium: boolean;
  trialStartDate: Date;
  withCard: boolean;
}

export const toView = (data: SubscriptionResponse): SubscriptionView => {
  const view = new SubscriptionView();
  view.paymentProvider = data.payment_provider;
  view.paymentProviderCustomerId = data.payment_provider_customer_id;
  view.paymentCycle = data.payment_cycle;
  view.fee = data.fee;
  view.currency = data.currency;
  view.id = data.subscription_id;
  view.active = data.active;
  view.startDate = new Date(data.date_start);
  view.endDate = new Date(data.date_end);
  view.renewalDate = new Date(data.date_renewal);
  view.tier = data.tier;
  view.comment = data.comment;
  view.autoRenew = data.auto_renew;
  view.isPremium = data.tier === "premium";
  view.trialStartDate = new Date(data.trial_start);
  view.withCard = data.with_card;
  return view;
};
